const IDENTITY_DOC_PATTERN = /^([0-9]{7,8}|[XYZ][0-9]{7})[A-Z]$/i;
const IDENTITY_DOC_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";

export const IDENTITY_DOC_I18N_KEYS = {
  invalidChecksum: "prompt.validation.invalidDocument",
} as const;

export function normalizeIdentityDoc(value?: string | null) {
  if (typeof value !== "string") {
    return "";
  }

  return value.replace(/[\s.-]/g, "").toUpperCase();
}

function mapIdentityDocPrefix(value: string) {
  if (value.startsWith("X")) return `0${value.slice(1)}`;
  if (value.startsWith("Y")) return `1${value.slice(1)}`;
  if (value.startsWith("Z")) return `2${value.slice(1)}`;
  return value;
}

export function hasValidIdentityDocChecksum(value?: string | null) {
  const normalizedIdentityDoc = normalizeIdentityDoc(value);

  if (!IDENTITY_DOC_PATTERN.test(normalizedIdentityDoc)) {
    return false;
  }

  const mappedIdentityDoc = mapIdentityDocPrefix(normalizedIdentityDoc);

  const letter = normalizedIdentityDoc.slice(-1);
  const numericString = mappedIdentityDoc.slice(0, -1);

  const numericPart = Number.parseInt(numericString, 10);

  const expectedLetter = IDENTITY_DOC_LETTERS[numericPart % 23];

  return letter === expectedLetter;
}

export function isValidDni(value?: string | null) {
  return hasValidIdentityDocChecksum(value);
}

export function getDniValidationMessageKey(value?: string | null) {
  return isValidDni(value) ? undefined : IDENTITY_DOC_I18N_KEYS.invalidChecksum;
}
